import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'We listened to every single message on our drive to the honeymoon. I cried happy tears the entire time.',
    author: 'Sarah & James',
    date: 'June 2025'
  }, {
    quote: 'Our guests loved it! Even my 85-year-old grandma figured it out. The messages are pure gold.',
    author: 'Emily & David',
    date: 'May 2025'
  }, {
    quote: 'So much better than a rental phone. We got 47 voicemails and every one is a treasure.',
    author: 'Rachel & Michael',
    date: 'July 2025'
  }];
  return <section className="py-24 bg-cream-100 text-brown-900" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4" data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-285">
          <h2 className="text-4xl md:text-5xl font-serif italic mb-4" data-id="element-286">
            Loved by Couples Everywhere
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-287">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 relative" data-id="element-288">
              <Quote className="w-10 h-10 text-accent-pink/20 absolute top-6 right-6" data-id="element-289" />

              <div className="flex space-x-1 mb-6" data-id="element-290">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-291" />)}
              </div>

              <p className="text-brown-900 italic text-lg mb-6 leading-relaxed" data-id="element-292">
                "{testimonial.quote}"
              </p>

              <div data-id="element-293">
                <p className="font-bold text-brown-900" data-id="element-294">{testimonial.author}</p>
                <p className="text-sm text-cream-500" data-id="element-295">{testimonial.date}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}